import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fetchCategoryTree, filterCategoryTree } from '../actions/CategoryCreators';
import { bindActionCreators } from 'redux';
import Loading from '../components/loading';
import TreeSelect from 'rc-tree-select';
import { DEPRECATED_CATEGORY_ID } from '../common/constants';
import 'rc-tree-select/assets/index.css';

// Deprecated, should not use this component any more, use the antd categorySelect
class CategoryTreeSelect extends Component {
    state = {
        searchValue: '',
        dropDownOpen: false,
    }

    componentDidMount() {
        if (!this.props.options) {
            this.props.fetchCategoryTree();
        }
    }

    onChange = (value, nodeInfo) => {
        if (this.props.onChange) {
            this.props.onChange(value, nodeInfo.triggerNode.props.children);
        }
    }

    onDropdownVisibleChange = (v, info) => {
        this.setState({
            dropDownOpen: v,
        });
    }

    filterTree = (searchValue) => {
        this.props.filterCategoryTree(searchValue);
    }

    render() {
        if (!this.props.options) {
            return (
                <div style={{
                    width: '100%',
                    position: 'relative',
                    height: '100px'
                }}>
                    <Loading spinning />
                </div>
            )
        }
        // let otherOpt = {
        //     key:'other',
        //     title:'other',
        //     value:'other',
        //     disabled:false,
        // }
        // this.props.options.push(otherOpt)
        return (
            <TreeSelect
                style={ { width: '100%' } }
                transitionName="rc-tree-select-dropdown-slide-up"
                choiceTransitionName="rc-tree-select-selection__choice-zoom"
                dropdownStyle={ { maxHeight: 600, overflow: 'auto' } }
                placeholder={ <i>请下拉选择</i> }
                searchPlaceholder="please search"
                multiple
                allowClear
                value={ this.props.selectedCategories }
                treeData={ this.props.options }
                treeNodeFilterProp="title"
                filterTreeNode={ false }
                onSearch={this.filterTree}
                open={ this.state.dropDownOpen }
                onChange={ (key, value, nodeInfo) => this.onChange(key, nodeInfo) }
                onDropdownVisibleChange={ this.onDropdownVisibleChange }
            />
        )
    }
}

function convertTreeNodeToOption(treeNode, titlePrefix) {
    let option = {
        key: treeNode.category.id,
        title: treeNode.category.id + '-' + titlePrefix + treeNode.category.displayTerm + '(' + treeNode.category.term + ')',
        value: treeNode.category.id,
        disabled: false,
    };
    if (treeNode.children && treeNode.children.length > 0) {
        titlePrefix = titlePrefix + treeNode.category.displayTerm + '-';
        let children = [];
        for (var i = 0; i < treeNode.children.length; i++) {
            let cNode = treeNode.children[i];
            let cOption = convertTreeNodeToOption(cNode, titlePrefix);
            children.push(cOption);
        }
        option.children = children;
    }
    return option;
}

function convertCategoryToTreeOptions(categories, deprecateOldCategories = false) {
    let options;
    if (categories.categoryTree) {
        options = [];
        for (var i = 0; i < categories.categoryTree.children.length; i++) {
            let cNode = categories.categoryTree.children[i];
            if(DEPRECATED_CATEGORY_ID.indexOf(cNode.category.id) < 0 && deprecateOldCategories){
                options.push(convertTreeNodeToOption(cNode, ''));
            }
        }
    }
    return options;
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({ fetchCategoryTree, filterCategoryTree}, dispatch);
}

function mapStateToProps(state, _) {
    return {
        options: convertCategoryToTreeOptions(state.categories, _.deprecateOldCategories),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(CategoryTreeSelect);